// extracted by mini-css-extract-plugin
module.exports = {"root":"ninth_root__1fsRp","check":"ninth_check__2dlRS"};